import { matchPath } from 'react-router';
import { all, takeLatest, put, call, select, take } from 'redux-saga/effects';

import { restClient } from 'config/store/configureStore';
import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { APPLICATION_IS_READY } from 'modules/app/actionTypes';
import { applicationIsReady } from 'modules/app/selectors';
import * as lockerTypes from 'modules/lockers/actionTypes';
import * as actions from 'modules/planning/actions';
import * as types from 'modules/planning/actionTypes';
import { getParameters, getSingleLockerId } from 'modules/planning/selectors';
import { getCurrentLocation } from 'selectors/router';

function* getLockersCalendar(action) {
  const { request } = action.payload;
  if (request.params.dealerId) {
    try {
      const response = yield call(restClient.request, request);
      yield put(actions.fetchCalendarLockersSuccess(request.params.from, response.data));
    } catch (message) {
      yield put(actions.fetchCalendarLockersError(message));
    }
  }
}
function* getLockerCalendar(action) {
  const { request } = action.payload;
  try {
    const response = yield call(restClient.request, request);
    yield put(actions.fetchCalendarLockerSuccess(request.params.from, response.data));
  } catch (message) {
    yield put(actions.fetchCalendarLockerError(message));
  }
}

function* refreshLocker() {
  const params = yield select(getParameters);
  const lockerId = yield select(getSingleLockerId);
  if (lockerId === null) {
    yield put(actions.fetchCalendarLockers(params));
  } else {
    // We omit filters when looking for a single locker calendar
    yield put(
      actions.fetchCalendarLocker(lockerId, {
        ...params,
        filters: {},
      })
    );
  }
}

function* afterSetDealerId() {
  const location = yield select(getCurrentLocation);
  const match = matchPath(PATH.KEY_DROP_OFF_LOCKER_PLANNING.path, location);
  const isReady = yield select(applicationIsReady);

  if (match) {
    if (!isReady) {
      yield take(APPLICATION_IS_READY);
    }

    yield refreshLocker();
  }
}

export default function* lockersCalendarSagas() {
  const refreshActions = [
    types.SET_SELECTED_LOCKER_ID,
    types.INCREMENT_SELECTED_DAY,
    types.DECREMENT_SELECTED_DAY,
    types.SET_SELECTED_DAY,
    types.SET_PLANNING_FILTER,
    types.REMOVE_PLANNING_FILTER,
    types.CLEAR_PLANNING_FILTERS,
    lockerTypes.REACTIVATE_LOCKER_SUCCESS,
    lockerTypes.DEACTIVATE_LOCKER_SUCCESS,
  ];
  yield all([
    yield takeLatest(types.GET_LOCKERS_CALENDAR, getLockersCalendar),
    yield takeLatest(types.GET_LOCKER_CALENDAR, getLockerCalendar),
    yield takeLatest(SELECT_DEALER, afterSetDealerId),
    yield takeLatest(refreshActions, refreshLocker),
  ]);
}
